import React, { useEffect, useContext, useState } from "react";
import { UserContext } from "../contexts/user.context";
// import { useNavigate } from "react-router-dom";
import { BSON } from "realm-web";

import Slider from "react-slick";
import "../slick/slick.css";
import "../slick/slick-theme.css";
import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import Box from "@mui/material/Box";
// import papaImage from "../assets/man1.png";
// import maImage from "../assets/lady1.png";
// import auImage from "../assets/lady2.png";
// import User1 from "../assets/img-tuser1.png";
// import User2 from "../assets/img-tuser2.png";
// import User3 from "../assets/img-tuser3.png";
// import User4 from "../assets/img-tuser4.png";
import faceIcon from "../assets/icon-patient-photo.png";
// import { textAlign } from "@mui/system";
import Typography from "@mui/material/Typography";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import "./HealthReports.css";

// const handleDragStart = (e) => e.preventDefault();

// const items = [
//   <img src={papaImage} onDragStart={handleDragStart} role="presentation" />,
//   <img src={maImage} onDragStart={handleDragStart} role="presentation" />,
//   <img src={auImage} onDragStart={handleDragStart} role="presentation" />,
// ];

const CarouselSlider = () => {
  // const [status, setStatus] = useState("0");
  const [lovedones, setlovedOnes] = useState([]);
  // const [selLid, setSelLId] = useState("");

 // const navigate = useNavigate();
  const { user, selectedPatient } = useContext(UserContext);

  useEffect(() => {
    loadUser(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  const loadUser = async () => {
    //   console.log('user:',user.id);
    //   console.log('location:',location.state.lid);
    if (user) {
      let ccid = BSON.ObjectID(user.id).toString();
      //  const lovd = user.functions.getLovedOneCP(ccid); // one loved one based on care manager id
      const lovd = user.functions.getLovedOnes(ccid); // to fetch all loved ones of that care taker
      // console.log('else direct:',ccid);
      lovd.then((resp) => {
        if (resp) {
        //  setStatus("1");
          //  setpName(resp.displayName);
          // setSelLId(resp._id.toString());
          setlovedOnes(resp);
       //   console.log("res:", resp);
        } else {
          alert("Loved Ones Not Created..");
          // navigate(`/addLovedOnes`);
        }
      });
    }
  };

  const onSubmit = (rtype) => {
   // console.log("selected Id:", rtype);
   // setSelLId(rtype);
   selectedPatient(rtype);  
  };

  function NextArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{ marginTop: "-2rem", marginRight: "0.5rem", color: "gray" }}
        onClick={onClick}
      >
        <ArrowForwardIosIcon />
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{
          marginTop: "-2rem",
          marginLeft: "0.2rem",
          color: "gray",
        }}
        onClick={onClick}
      >
        <ArrowBackIosNewIcon />
      </div>
    );
  }

  var settings = {
    className: "center",
    focusOnSelect: false,
    centerPadding: "60px",
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          focusOnSelect: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          focusOnSelect: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
        },
      },
      {
        breakpoint: 430,
        settings: {
          focusOnSelect: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <>
      <Card
        //  sx={{ maxWidth: 500 }}
        style={{
          borderTop: "6px solid #1D5A90",
          // marginTop: "210px",
          marginTop: "0px",
          marginBottom: "0rem",
          borderRadius: "10px",
          padding: "20pt",
          width: "100%",
          maxWidth: "500px",
          height: "190px",
          position: "absolute",
          zIndex: "1",
        }}
        className="carousel"
      >
        <Typography
          style={{
            marginTop: "-1rem",
            marginBottom: "0.5rem",
            color: "#209F85",
            marginLeft: "-1rem",
            fontFamily: "Helvetica",
            fontSize: "16px",
          }}
        >
          Select your loved one
        </Typography>
        <Slider {...settings} style={{ fontFace: "Arial" }}>
          {lovedones.map((item) => (
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: "30px",
                alignSelf: "center",
                height: "140px",
                marginTop: "0rem",
                marginBottom: "0rem",
              }}
            >
              <Card
                style={{
                  borderTop: "6px solid #1D5A90",
                  borderRadius: "10pt",
                  // boxShadow: "0 18px 40px -12px rgba(0,0,0,0.3)",
                  width: "110px",
                  height: "110px",
                  cursor: "pointer",
                  marginLeft: "1.2rem",
                  marginTop: "0rem",
                  marginBottom: "0rem",
                }}
                onClick={() => onSubmit(`${item._id.toString()}`)}
              >
                <div style={{ height: "5px" }}></div>
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    // paddingLeft: "15px",
                    // paddingBottom: "15px",
                    marginTop: "0rem",
                    marginBottom: "0rem",
                    display: "flex",
                  }}
                >
                  <img
                    src={faceIcon}
                    role="presentation"
                    style={{ height: "60px" }}
                    alt = ""
                  />
                </div>
                <div style={{ height: "10px" }}></div>
                <div style={{ textAlign: "center", color: "#707070" }}>
                  {item.displayName}
                </div>
                <div style={{ height: "5px" }}></div>
              </Card>
            </div>
          ))}
        </Slider>
      </Card>
    </>
  );
};

export default CarouselSlider;
